import React, { Fragment } from 'react';
import { Grid, Button, FormLabel } from '@material-ui/core';
import { useStyle } from './style';

export const EirOrderSummary = props => {
    const classes = useStyle();
    const { buttonLabel, price, handleNext, continueDisabled } = props;

    return (
        <Fragment>
            <Grid container className={classes.footer}>
                <Grid item>
                    <FormLabel className={classes.summaryLabel}>
                        {' '}
                        Your order total: &euro;{price}{' '}
                    </FormLabel>
                </Grid>
                <Grid item>
                    <Button
                        variant='contained'
                        color='secondary'
                        disabled={continueDisabled}
                        className={classes.summaryButton}
                        onClick={handleNext}>
                        {buttonLabel}
                    </Button>
                </Grid>
            </Grid>
        </Fragment>
    );
};

